import { Fragment } from 'react';

import { LANGUAGES } from '@/components/LanguageSwitcher/LanguageSwitcher.constants';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { useLanguageSwitcher } from '@/hooks/useLanguageSwitcher';

import * as S from './InlineLanguageSwitcher.styles';

export const InlineLanguageSwitcher = () => {
  const { currentLanguage, handleLanguageChange } = useLanguageSwitcher();

  return (
    <S.LanguageSwitcherWrapper>
      {LANGUAGES.map(({ label, code }, index) => (
        <Fragment key={index}>
          <S.LanguageOption
            key={code}
            $isSelected={code === currentLanguage}
            onClick={() => handleLanguageChange(code)}
          >
            <Typography variant="body1">{label}</Typography>
          </S.LanguageOption>
          {index < LANGUAGES.length - 1 && <S.Separator>·</S.Separator>}
        </Fragment>
      ))}
    </S.LanguageSwitcherWrapper>
  );
};
